//src/components/common/projectCodeNavBar/ProjectCodeNavbar.js
import React, { useState } from "react";
import { validateProjectCodes } from "../../../api/project/projectApi";
import { useNavigate } from "react-router-dom";
import { MdCancel, MdSend } from "react-icons/md";
import { FaLink } from "react-icons/fa";

const ProjectCodeNavbar = () => {
  const [projectCode, setProjectCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();

  const validateProjectCode = async () => {
    try {
      const response = await validateProjectCodes(projectCode);
      const { status, message, project_id } = response.data;

      if (status) {
        navigate("/learner-details", {
          state: { projectId: project_id, projectCode },
        });
      } else {
        setErrorMessage(message);
      }
    } catch (error) {
      console.error("Error validating project code:", error);
      setErrorMessage("Invalid project code. Please enter a correct code.");
    }
  };

  const onClose = () => setIsVisible(false);

  if (!isVisible) return null;

  return (
    <div className="sticky top-16 z-50 w-full backdrop-blur-md bg-white/70 border-b border-gray-200 shadow-sm">
      {/* <div className="w-full backdrop-blur-md bg-white/70 border-b border-gray-200 shadow-sm"> */}

      <div className="max-w-4xl mx-auto flex items-center justify-between px-4 py-2">

        {/* INPUT AREA */}
        <div className="flex items-center gap-2 w-full max-w-md">

          {/* INPUT */}
          <div className="flex items-center w-full bg-white border border-gray-300 rounded-full px-3 py-1.5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-400 transition">

            <FaLink className="text-indigo-500 mr-2 text-sm" />

            <input
              type="text"
              value={projectCode}
              onChange={(e) => setProjectCode(e.target.value)}
              placeholder="Enter your assessment code..."
              className="w-full outline-none bg-transparent text-sm"
              onKeyDown={(e) => {
                if (e.key === "Enter") validateProjectCode();
              }}
            />
          </div>

          {/* ICON BUTTON */}
          <button
            onClick={validateProjectCode}
            className="flex items-center justify-center bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-2 rounded-full shadow-md hover:scale-105 transition"
          >
            <MdSend className="text-lg" />
          </button>
        </div>

        {/* CLOSE BUTTON */}
        <MdCancel
          onClick={onClose}
          className="text-xl text-gray-500 hover:text-red-500 cursor-pointer ml-3 transition"
        />
      </div>

      {/* ERROR */}
      {errorMessage && (
        <p className="text-red-500 text-xs px-4 pb-2">{errorMessage}</p>
      )}
    </div>
  );
};

export default ProjectCodeNavbar;